var map = {
	"./ad.png": "XG/i",
	"./ae.png": "3Sc1",
	"./af.png": "NgPq",
	"./ag.png": "edWT",
	"./ai.png": "+5kn",
	"./al.png": "PrTq",
	"./am.png": "aqnr",
	"./an.png": "cDZ2",
	"./ao.png": "/Ux3",
	"./ar.png": "8GTC",
	"./as.png": "LGWT",
	"./at.png": "riWI",
	"./au.png": "U78t",
	"./aw.png": "SUQu",
	"./ax.png": "SssG",
	"./az.png": "6tgh",
	"./ba.png": "kiaF",
	"./bb.png": "P9UR",
	"./bd.png": "0oh0",
	"./be.png": "VMQ2",
	"./bf.png": "Fq0+",
	"./bg.png": "CQnZ",
	"./bh.png": "eHgv",
	"./bi.png": "SwzK",
	"./bj.png": "REOb",
	"./bm.png": "QfO7",
	"./bn.png": "IGqY",
	"./bo.png": "YMje",
	"./br.png": "fLaP",
	"./bs.png": "Qoee",
	"./bt.png": "InDv",
	"./bv.png": "jE8J",
	"./bw.png": "K3iZ",
	"./by.png": "rbS8",
	"./bz.png": "54KC",
	"./ca.png": "gkg6",
	"./catalonia.png": "zNlR",
	"./cc.png": "y6s/",
	"./cd.png": "zF9p",
	"./cf.png": "KhWg",
	"./cg.png": "Tu0k",
	"./ch.png": "8jSF",
	"./ci.png": "aUhp",
	"./ck.png": "3DIc",
	"./cl.png": "7oIW",
	"./cm.png": "SkY8",
	"./cn.png": "6x4r",
	"./co.png": "kXFy",
	"./cr.png": "eoFq",
	"./cs.png": "4zZe",
	"./cu.png": "BIOA",
	"./cv.png": "a3M9",
	"./cx.png": "e8SH",
	"./cy.png": "kOi6",
	"./cz.png": "PZKX",
	"./de.png": "Ww/j",
	"./dj.png": "+8qU",
	"./dk.png": "aGlD",
	"./dm.png": "vUxY",
	"./do.png": "3ulp",
	"./dz.png": "tdwC",
	"./ec.png": "owPf",
	"./ee.png": "/Wyo",
	"./eg.png": "tgKc",
	"./eh.png": "Vvpr",
	"./england.png": "ogCB",
	"./er.png": "QCtp",
	"./es.png": "hPQb",
	"./et.png": "KK+D",
	"./europeanunion.png": "ovNk",
	"./fam.png": "mBOG",
	"./fi.png": "tmo1",
	"./fj.png": "LzgM",
	"./fk.png": "ime6",
	"./fm.png": "2sNA",
	"./fo.png": "Vp4K",
	"./fr.png": "R7ir",
	"./ga.png": "DaTY",
	"./gb.png": "9ttP",
	"./gd.png": "R1Bl",
	"./ge.png": "lnSK",
	"./gf.png": "0p2h",
	"./gg.png": "BbJp",
	"./gh.png": "C52r",
	"./gi.png": "/jT2",
	"./gl.png": "m4sj",
	"./gm.png": "O9Zq",
	"./gn.png": "JGdg",
	"./gp.png": "BsDg",
	"./gq.png": "LmaG",
	"./gr.png": "bXvw",
	"./gs.png": "bsKk",
	"./gt.png": "e+LH",
	"./gu.png": "Ct8U",
	"./gw.png": "DDk1",
	"./gy.png": "vKFO",
	"./hk.png": "s3PQ",
	"./hm.png": "2NJg",
	"./hn.png": "X8/Z",
	"./hr.png": "OTB4",
	"./ht.png": "oal4",
	"./hu.png": "vJtj",
	"./id.png": "Z8uE",
	"./ie.png": "pP+a",
	"./il.png": "lKtp",
	"./in.png": "vYQb",
	"./io.png": "Het/",
	"./iq.png": "qQKO",
	"./ir.png": "lpUr",
	"./is.png": "0+tJ",
	"./it.png": "WQqp",
	"./jm.png": "B9KC",
	"./jo.png": "z4Dz",
	"./jp.png": "mrJH",
	"./ke.png": "TdAO",
	"./kg.png": "GLOB",
	"./kh.png": "+YqN",
	"./ki.png": "WR0c",
	"./km.png": "n5Kd",
	"./kn.png": "XJrS",
	"./kp.png": "ZOP1",
	"./kr.png": "8hGh",
	"./kw.png": "rZSm",
	"./ky.png": "eLXA",
	"./kz.png": "kGe+",
	"./la.png": "5+cn",
	"./lb.png": "y1JJ",
	"./lc.png": "Wio3",
	"./li.png": "QjLw",
	"./lk.png": "8F4Z",
	"./lr.png": "XjMb",
	"./ls.png": "0Q18",
	"./lt.png": "o3xn",
	"./lu.png": "z0iQ",
	"./lv.png": "BCY6",
	"./ly.png": "Mx5N",
	"./ma.png": "ldpy",
	"./mc.png": "aRqz",
	"./md.png": "ELow",
	"./me.png": "7oJw",
	"./mg.png": "i/1p",
	"./mh.png": "WEv/",
	"./mk.png": "Qqp9",
	"./ml.png": "qnH5",
	"./mm.png": "yC2U",
	"./mn.png": "4VgD",
	"./mo.png": "GWO9",
	"./mp.png": "we/j",
	"./mq.png": "3PAv",
	"./mr.png": "4MwX",
	"./ms.png": "DsyR",
	"./mt.png": "zZkG",
	"./mu.png": "9fZH",
	"./mv.png": "X52i",
	"./mw.png": "u54c",
	"./mx.png": "muEd",
	"./my.png": "fUim",
	"./mz.png": "EPxq",
	"./na.png": "bdNg",
	"./nc.png": "UCPZ",
	"./ne.png": "Xap+",
	"./nf.png": "sTbT",
	"./ng.png": "v894",
	"./ni.png": "0f15",
	"./nl.png": "APgl",
	"./no.png": "KvzO",
	"./np.png": "arLc",
	"./nr.png": "YsEx",
	"./nu.png": "4+Cp",
	"./nz.png": "xn1W",
	"./om.png": "Nw/w",
	"./pa.png": "LYJ7",
	"./pe.png": "ohB1",
	"./pf.png": "Uyrp",
	"./pg.png": "ek9z",
	"./ph.png": "6k4/",
	"./pk.png": "wlIF",
	"./pl.png": "3vzy",
	"./pm.png": "Dt2D",
	"./pn.png": "KwVN",
	"./pr.png": "mBfC",
	"./ps.png": "uqt0",
	"./pt.png": "mrrk",
	"./pw.png": "lr0m",
	"./py.png": "dT2s",
	"./qa.png": "NAtz",
	"./re.png": "m3hX",
	"./ro.png": "lDtb",
	"./rs.png": "KK30",
	"./ru.png": "TPPH",
	"./rw.png": "O6yu",
	"./sa.png": "e2q5",
	"./sb.png": "RuGV",
	"./sc.png": "jpFY",
	"./scotland.png": "IDjK",
	"./sd.png": "3yhp",
	"./se.png": "2uMc",
	"./sg.png": "p/jH",
	"./sh.png": "oUTE",
	"./si.png": "O9uw",
	"./sj.png": "Xkbg",
	"./sk.png": "1iyh",
	"./sl.png": "IV3t",
	"./sm.png": "0fVF",
	"./sn.png": "erEr",
	"./so.png": "BRiM",
	"./sr.png": "kXuL",
	"./st.png": "gz+J",
	"./sv.png": "owJh",
	"./sy.png": "57BE",
	"./sz.png": "qRec",
	"./tc.png": "72FO",
	"./td.png": "jCZx",
	"./tf.png": "B2im",
	"./tg.png": "q6Lu",
	"./th.png": "j5zQ",
	"./tj.png": "NG6R",
	"./tk.png": "ih+Q",
	"./tl.png": "LK1L",
	"./tm.png": "1mvW",
	"./tn.png": "D0So",
	"./to.png": "EE7+",
	"./tr.png": "q6sy",
	"./tt.png": "IZln",
	"./tv.png": "28ac",
	"./tw.png": "7hs8",
	"./tz.png": "ncBE",
	"./ua.png": "ymjS",
	"./ug.png": "O9MS",
	"./um.png": "w+pJ",
	"./us.png": "+W/7",
	"./uy.png": "nRyy",
	"./uz.png": "Qx54",
	"./va.png": "oayI",
	"./vc.png": "hVnl",
	"./ve.png": "7ofC",
	"./vg.png": "aOkr",
	"./vi.png": "WeBg",
	"./vn.png": "/6/V",
	"./vu.png": "kA//",
	"./wales.png": "QzZn",
	"./wf.png": "5yY0",
	"./ws.png": "6Nz2",
	"./ye.png": "+xUX",
	"./yt.png": "DDaC",
	"./za.png": "FXjg",
	"./zm.png": "Xdmr",
	"./zw.png": "a/JN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Gh4";